// ------------ REAL APIs ------------
import AuthApi from './AuthApi'
import MediaCorpPlayerApi from 'services/mediacorp/PlayerApi'
import PlayerAnalyticsApi from 'services/adobe/playerAnalytics'
import ChannelApi from 'services/nagra/ChannelApi'
import DeviceApi from 'services/nagra/DeviceApi'
import FavouritesApi from 'services/nagra/FavouritesApi'
import RecordingsApi from 'services/nagra/RecordingsApi'
import PlayerApi from './PlayerApi'
import ProgramApi from 'services/nagra/ProgramApi'
import PurchaseApi from './PurchaseApi'
import ImageApi from './ImageApi'
import SettingsApi from './SettingsApi'
import UserPreferencesApi from 'services/nagra/UserPreferencesApi'
import ReportActivityApi from 'services/nagra/ReportActivityApi'
import ProxyApi from 'services/proxy'

export default class StarhubApi {
    constructor(config, otherApis) {
        const _config = {
            ...config,
            useNagraLegacyData: true,
        }
        this.userPreferencesApi = new UserPreferencesApi(_config)
        this.settingsApi = new SettingsApi(_config, {
            ...otherApis,
            userPreferencesApi: this.userPreferencesApi,
        })
        this.recordingsApi = new RecordingsApi(_config)
        this.authApi = new AuthApi(_config, {
            ...otherApis,
            settingsApi: this.settingsApi,
            recordingsApi: this.recordingsApi,
        })
        this.playerAnalyticsApi = new PlayerAnalyticsApi(_config, { ...otherApis })
        this.mediaCorpPlayerApi = new MediaCorpPlayerApi(_config, {
            ...otherApis,
            playerAnalyticsApi: this.playerAnalyticsApi,
        })
        this.reportActivityApi = new ReportActivityApi(_config)
        this.proxyApi = new ProxyApi(_config)

        this.playerApi = new PlayerApi(_config, {
            ...otherApis,
            authApi: this.authApi,
            mediaCorpPlayerApi: this.mediaCorpPlayerApi,
            reportActivityApi: this.reportActivityApi,
        })
        this.channelApi = new ChannelApi(_config, {
            ...otherApis,
            userPreferencesApi: this.userPreferencesApi,
        })
        this.programApi = new ProgramApi(_config, {
            ...otherApis,
            proxyApi: this.proxyApi,
            userPreferencesApi: this.userPreferencesApi,
        })
        this.favouritesApi = new FavouritesApi(_config, {
            ...otherApis,
            proxyApi: this.proxyApi,
            userPreferencesApi: this.userPreferencesApi,
        })
        this.deviceApi = new DeviceApi(_config, otherApis)
        this.purchaseApi = new PurchaseApi(_config, { ...otherApis, authApi: this.authApi })

        this.imageApi = new ImageApi(_config)
    }
}
